import { Form } from "antd";
import * as React from "react";
import { zAttrMeta } from "src/business/attribute";
import { debounce, DebounceCounter } from "src/common/debounce";
import { onError } from "src/common/onError";

import { AttrFeatures } from "../AttrFeatures";
import * as styles from "./AttrMetaEditorForm.module.less";
import { AttrMetaEditorNode } from "./AttrMetaEditorNode";
import { filterOptionalDiscUnions } from "./filterOptionalDiscUnions";

type PropsAttrMetaEditorForm = {
  srcValue: unknown;
  onChange(newValue: unknown): void;
  attrFeatures: AttrFeatures;
};

const validatorCounter: DebounceCounter = {};

export const AttrMetaEditorForm: React.FC<PropsAttrMetaEditorForm> = (
  props,
) => {
  const { srcValue, onChange, attrFeatures } = props;
  const [form] = Form.useForm();
  const validate = () => {
    form.validateFields().catch((res) => {
      if (res instanceof Error) onError(res);
    });
  };
  const smartValidate = () => {
    debounce(validatorCounter, 200, validate);
  };
  React.useEffect(() => {
    if (JSON.stringify(form.getFieldsValue()) !== JSON.stringify(srcValue)) {
      form.resetFields();
      form.setFieldsValue(srcValue);
      smartValidate();
    }
  }, [srcValue]);
  return (
    <Form
      layout="vertical"
      form={form}
      className={styles.frame}
      onValuesChange={(_, all) => {
        const data = filterOptionalDiscUnions(all);
        onChange(data);
        smartValidate();
      }}
    >
      <div className={styles.content}>
        <AttrMetaEditorNode
          node={zAttrMeta}
          path={[]}
          attrFeatures={attrFeatures}
        />
      </div>
    </Form>
  );
};
